export default "__VITE_ASSET__59beccad__"